/**
 * Builds the absolute canonical URL for a public page.
 *
 * `jobShopBaseUrl` is the jobshop's absolute base URL — origin plus any path
 * prefix, e.g. `https://karriere.acme.com/jobs/`. `relativePath` is the page's
 * path relative to that base (the route slug, without a leading slash or query
 * string); an empty path yields the jobshop homepage.
 */
export function buildCanonicalUrl(jobShopBaseUrl: string, relativePath = ""): string {
  if (!jobShopBaseUrl)
    return ""

  // A trailing slash makes the base a directory, so relative resolution appends
  // to the prefix instead of replacing its last segment.
  const base = jobShopBaseUrl.endsWith("/") ? jobShopBaseUrl : `${jobShopBaseUrl}/`
  const path = relativePath.replace(/^\/+/, "")

  return new URL(path, base).href
}
